import { Grid, Typography } from '@material-ui/core';
import { ChatIcon } from '@flos/react-components';
import { getContactUsURL } from '../../common/utils/helpers/GenericHelpers';
import { MIN_AGE, MAX_AGE } from '../../common/interface/IPayload';
import { baseStyles } from '../../theme/base.styles';

export const ErrorScreenView = (): JSX.Element => {
  const baseClasses = baseStyles();
  return (
    <Grid item xs={12} md={12} className={baseClasses.main}>
      <ChatIcon />
      <Typography variant="h6" color="textPrimary" paragraph className={baseClasses.spacingLarge}>
        <strong>
          Alder skal være mellem {MIN_AGE} og {MAX_AGE} år
        </strong>
      </Typography>
      <Typography variant="subtitle1" color="textPrimary" paragraph className={baseClasses.spacingNormal}>
        For at købe en indboforsikring online, skal man være mellem {MIN_AGE} og {MAX_AGE} år.
      </Typography>
      <Typography variant="subtitle1" color="textPrimary" paragraph className={baseClasses.spacingNormal}>
        Hvis du har yderligere spørgsmål, kan du <a href={getContactUsURL()}>kontakte os</a>
      </Typography>
    </Grid>
  );
};
